// Centralized, easily-editable site content.
// Update copy, services, FAQs, and gallery here.

export const site = {
  brand: "Eternal Care",
  tagline: "Honoring Lives. Celebrating Individuality.",
  taglines: [
    "Honoring Lives. Celebrating Individuality.",
    "Because Every Life Deserves a Beautiful Farewell.",
    "Life Is Unique. The Goodbye Should Be Too.",
    "Be Proud. Be You. Be Remembered.",
  ],
  phone: "832-784-3185",
  phoneHref: "tel:+18327843185",
  email: "info@eternalcareco.com",
  emailHref: "mailto:info@eternalcareco.com",
  website: "www.eternalcare.com",
  cityLine: "Houston, Texas & Surrounding Communities",
  logo:
    "https://customer-assets.emergentagent.com/job_celebrate-farewell/artifacts/nif7eio7_9b99f115-6cb3-4d74-a227-d8461cb100a7.png",
  socials: {
    instagram: "#",
    facebook: "#",
    tiktok: "#",
  },
  images: {
    hero:
      "https://customer-assets.emergentagent.com/job_92597946-c4f1-456a-983a-2232e66a69bf/artifacts/lfxcq6mu_5ebd133e-f825-4783-a8d2-71a18ee87747.png",
    flowers1:
      "https://customer-assets.emergentagent.com/job_celebrate-farewell/artifacts/03t0d8ml_pexels-hson-17635080.jpg",
    flowers2:
      "https://customer-assets.emergentagent.com/job_celebrate-farewell/artifacts/gosbsjnu_pexels-piotr-arnoldes-7862031-6794613.jpg",
    flowers3:
      "https://customer-assets.emergentagent.com/job_celebrate-farewell/artifacts/evqk8npg_pexels-cileklipalet-34463058.jpg",
  },
  services: [
    {
      key: "funeral-transportation",
      title: "Funeral Transportation",
      blurb:
        "A graceful, dignified arrival in our signature pink hearse, every detail handled with quiet care.",
      icon: "heart",
    },
    {
      key: "celebration-of-life",
      title: "Celebration of Life",
      blurb:
        "Lift the day with light, warmth, and color. Designed for gatherings that honor a life beautifully lived.",
      icon: "sparkles",
    },
    {
      key: "personalized-hearse",
      title: "Personalized Hearse Experiences",
      blurb:
        "Florals, music cues, escort attire, bespoke moments tailored to your loved one's personality.",
      icon: "feather",
    },
    {
      key: "memorial-processions",
      title: "Memorial Processions",
      blurb:
        "Thoughtfully coordinated processions through the streets of Greater Houston with elegance and pace.",
      icon: "compass",
    },
    {
      key: "family-escort",
      title: "Family Escort Services",
      blurb:
        "Quiet, attentive transportation for the family, present when needed, invisible when not.",
      icon: "users",
    },
    {
      key: "custom-requests",
      title: "Custom Requests",
      blurb:
        "Have something specific in mind? We listen first, then craft a farewell that feels unmistakably them.",
      icon: "wand",
    },
  ],
  highlights: [
    {
      title: "Respectful Service",
      blurb: "Professional, compassionate care every step of the way.",
      icon: "heart",
    },
    {
      title: "Celebrate Individuality",
      blurb: "Honoring unique stories, personalities, and lives well lived.",
      icon: "flower",
    },
    {
      title: "Family Focused",
      blurb: "Supporting families with empathy, understanding, and guidance.",
      icon: "users",
    },
    {
      title: "Personalized Farewells",
      blurb:
        "Every detail tailored to reflect the life and legacy of your loved one.",
      icon: "feather",
    },
    {
      title: "Stand Out. Be Remembered.",
      blurb: "A unique way to honor a life that was extraordinary.",
      icon: "sparkles",
    },
  ],
  whyUs: [
    {
      title: "A Symbol of Compassion",
      body:
        "The pink hearse is a quiet promise, that this farewell will be soft, beautiful, and full of love.",
    },
    {
      title: "Detail That Feels Personal",
      body:
        "From florals to driver attire, we shape every detail around the person you're honoring.",
    },
    {
      title: "Houston-Rooted Care",
      body:
        "We know our city. Routes, timing, families, handled with quiet competence and warmth.",
    },
    {
      title: "Dignified, Always",
      body:
        "Color and softness do not replace dignity, they deepen it. We hold both, gently.",
    },
  ],
  serviceAreas: [
    "Houston",
    "Sugar Land",
    "Pearland",
    "Katy",
    "The Woodlands",
    "Pasadena",
    "Spring",
    "Cypress",
    "Missouri City",
    "League City",
    "Friendswood",
    "Greater Houston Area",
  ],
  testimonials: [],
  faqs: [
    {
      q: "What areas do you serve?",
      a: "We proudly serve Houston and the Greater Houston area, including Sugar Land, Pearland, Katy, The Woodlands, Pasadena, Spring, Cypress, Missouri City, League City, Friendswood, and many surrounding Texas communities.",
    },
    {
      q: "How far in advance should we contact you?",
      a: "Whenever you are ready. We accept requests on short notice and well in advance, the sooner we connect, the more personalized we can make the experience.",
    },
    {
      q: "Can services be personalized?",
      a: "Absolutely. From florals and music cues to escort attire and procession routing, every detail can be tailored to reflect your loved one's personality and story.",
    },
    {
      q: "Do you provide transportation for celebration of life events?",
      a: "Yes. The pink hearse is a beautiful centerpiece for celebrations of life, uplifting, memorable, and full of grace.",
    },
    {
      q: "What makes Eternal Care different?",
      a: "Our signature pink hearse, our drivers in elegant pink attire, and a deeply personal approach. We honor individuality with warmth, taste, and quiet luxury.",
    },
    {
      q: "Are custom requests available?",
      a: "Yes, we welcome custom requests. Share what feels right for your family, and we will design a farewell that feels unmistakably theirs.",
    },
  ],
  serviceTypeOptions: [
    "Funeral Transportation",
    "Celebration of Life",
    "Personalized Hearse Experience",
    "Memorial Procession",
    "Family Escort Service",
    "Custom Request",
    "Other / Not Sure",
  ],
};

export default site;
